<nav [ngClass]="sticky ? 'sticky-top' : ''">
  <div class="nav nav-tabs" role="tablist" style="overflow-x: auto; overflow-y:hidden; flex-wrap: nowrap;">
    <div class="navbar-scroller d-flex flex-row">
      @for (tab of tabs; track tab.uniqueTabItemId; let i = $index) {
        <a (click)="activateTab(tab, i)"
           [ngClass]="{active: tab == activeTab, 'text-invalid': tab['ngInvalid'], 'ng-invalid': tab['ngInvalid'], 'border-0': tab != activeTab}"
           class="nav-link" style="cursor: pointer; white-space: nowrap;">
          <ng-template [ngTemplateOutlet]="tab.tabHeader"></ng-template>
        </a>
      }
    </div>
  </div>
</nav>

@if (alwaysRender) {
  @for (tab of tabs; track tab.uniqueTabItemId; let i = $index) {
    @if (tab.alwaysRender || tab === activeTab) {
      <div [ngClass]="tab == activeTab ? ' ' : 'd-none'" [appValidator]="tab">
        <ng-template [ngTemplateOutlet]="tab.templateRef"></ng-template>
      </div>
    }
  }
} @else {
  <ng-template [ngTemplateOutlet]="activeTab.templateRef"></ng-template>
}
